import { browser } from "$app/environment";

let scrollPosition = 0;

/**
 * Locks the scroll of the page and saves the scroll position.
 * We need to save the scroll position because when unlocking the browser will scroll to the top of the page.
 */
export function lockScroll() {
  if (!browser) {
    return;
  }
  scrollPosition = window.pageYOffset;
  document.body.style.top = -scrollPosition + 'px';
  document.body.style.position = 'fixed';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.overflowY = 'scroll';
}

/**
 * Unlocks the scroll of the page and restores the scroll position to the one before locking.
 */
export function unlockScroll() {
  if (!browser) {
    return;
  }
  document.body.style.position = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.overflowY = '';
  window.scrollTo(0, scrollPosition);
  document.body.style.top = '';
}

/**
 * Scrolls to the top of a target element or the top of the page if no target element is provided.
 * 
 * @param targetElement The element to scroll to the top of.
 */
export function scrollToTop(targetElement: HTMLElement | null = null) {
  if (!targetElement) {
    window.scrollTo({ top: 0 });
    return;
  }
  let headerOffset = 65;
  if (window.innerWidth > 900) {
    headerOffset = 140;
  }
  const y = Math.max(0, targetElement.getBoundingClientRect().top + window.pageYOffset - headerOffset);
  window.scrollTo({ top: y });
}